import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'


function Footer() {
  const message = "Desire store Sharing";
  const title = document.title;
  const url = document.location.href;

  function handleShare() {
    if (navigator.share) {
      navigator
        .share({ message, title, url })
        .then(() => {
          console.log("Thanks For sharing!");
        })
        .catch(console.error);
    } else {
      if (
        window.confirm(
          "Sorry, your browser or device does not support sharing URLs. \nDo you want to copy the URL to your clipboard instead?"
        )
      ) {
        navigator.clipboard.writeText(window.document.location.href);
        alert("Link copied to clipboard!");
      }
    }
  }
  useEffect(() => {
    function handleClick() {
      window.scrollTo(0, 0);
    }

    const scrollLinks = document.querySelectorAll('.scroll-link');
    scrollLinks.forEach(link => link.addEventListener('click', handleClick));

    return () => {
      scrollLinks.forEach(link => link.removeEventListener('click', handleClick));
    };
  }, []);
  return (
    <div>

         <section className='footer'>
  
        <footer className="bottom">
          <div className="legal scroll-link">
            
          <Link to="/legal/licence">  <span> License </span></Link>
          <Link to="/legal/terms"><span> Terms </span></Link>
          <Link to="/legal/privacy"><span> Privacy </span></Link>
           <span style={{pointerEvents:"none"}} > © 2023 All rights reserved </span>
          </div>
        
          <div className="links">
           <Link to="https://github.com/ayushsolanki29"> <span className="fa-brands fa-github"></span></Link>
           <Link to="https://www.linkedin.com/in/ayush-solanki-a3909625a/">  <span className="fa-brands fa-linkedin"></span></Link>
           <Link to="https://www.youtube.com/@desirestore2047"> <span className="fa-brands fa-youtube"></span></Link>
           <Link to="mailto:desirestore.help@gmail.com"> <span className="fa-solid fa-envelope"></span></Link>
           <Link onClick={handleShare}> <span className="fa-solid fa-share-alt"></span></Link>
          </div>
        
        </footer>
        <div className="author">
         <p> Made with ❤️ by Ayush Solanki</p> 
          </div>
      </section>
    </div>
  )
}

export default Footer
